import { render, staticRenderFns } from "./DatafonoComponent.vue?vue&type=template&id=6913929b"
import script from "./DatafonoComponent.vue?vue&type=script&lang=js"
export * from "./DatafonoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports